import { useState, useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import ManageNews from '../AdminNews/ManageNew'
import UpdateActivity from '../AdminPages/RouterUpdateActivity'
import ManageStaff from '../AdminPages/ManageStaff'
import UpdateNavbar from '../AdminPages/UpdateNavbar'
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import UpdateAdminiApp from '../AdminiUpdate/UpdateAdminiApp'

function Login() {
  const [isLoaded, setIsLoaded] = useState(true);
  const [user, setUser] = useState([]);
  const navigate = useNavigate()
  const MySwal = withReactContent(Swal)

  useEffect(() => {
    async function postJSON() {
      try {
        const token = localStorage.getItem('token')
        const response = await fetch("https://test-api-liard.vercel.app/api/authen", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + token
          }
        });

        const result = await response.json();
        if (result.status === 'ok') {
          setUser(result.user)
          setIsLoaded(false)
        } else {
          MySwal.fire({
            html: <i>Login Failed</i>,
            icon: 'error'
          }).then((value) => {
            navigate('/admin')
          })
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }

    postJSON();
  }, [])

  const logout = () => {
    localStorage.removeItem('token')
    navigate('/admin')
  }

  return (
    <>
      <UpdateNavbar logout={logout} />
      <Routes>
        <Route path="/*" element={<ManageNews />} />
        <Route path="updateactivity/*" element={<UpdateActivity />} />
        <Route path="updateadministrator/*" element={<UpdateAdminiApp />} />
        <Route path="managestaff/*" element={<ManageStaff />} />
      </Routes>
    </>
  )
}

export default Login